module.exports = __webpack_public_path__ + "faq/img/unget-task1.a465744d.png";